import React, {useState, useEffect} from 'react'
import {
  Typography,
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import {useHistory} from 'react-router-dom'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import {MoonLoader} from 'react-spinners'
import axios from 'axios'
import {BEHAVIOUR_ASSESSMENT_FORM_INPUTS} from '../BEHAVIOUR_CONSTANTS'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import BackButton from '../../../../reusable-components/Buttons/BackButton'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import AssessmentTypeSelect from '../../../../reusable-components/AssesmentType/AssesmentType'
const BehaviourNotesAssessmentNew = () => {
  const [formData, setFormData] = useState<any>({})
  const [noteData, setNoteData] = useState<any>({
    noteType: '',
    assessmentType: '', 
  })
  const [uiElements, setUiElements] = useState<any>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const history = useHistory()
  const [images, setImages] = useState<string[]>([])
  const [selectedFiles, setSelectedFiles] = useState<File[]>([])
  const [uploadedFileKeys, setUploadedFileKeys] = useState<string[]>([])
  const [fileToKeyMap, setFileToKeyMap] = useState<Map<string, string>>(new Map()) // Track file hash to uploaded key
  const [isFormLoading, setIsFormLoading] = useState<boolean>(false)
  const [clients, setClients] = useState<any[]>([])
  const authUser = useSelector((state: {auth: any}) => state.auth)

  useEffect(() => {
    const fetchClients = async () => {
      try {
        setIsFormLoading(true)
        const response = await axios.get('/clients/getClientNames')
        const {data} = response?.data
        const updatedclients = [
          ...data.map((client) => ({label: client.fullName, value: client._id})),
        ]
        setClients(updatedclients)
        const updatedFormData = BEHAVIOUR_ASSESSMENT_FORM_INPUTS.map((item) => {
          if (item.name === 'clientId') {
            return {...item, options: updatedclients}
          }
          return item
        })
        setUiElements(updatedFormData)
      } catch (error) {
        console.error('Error fetching clients:', error)
      } finally {
        setIsFormLoading(false)
      }
    }
    fetchClients()
  }, [])

  const handleSubmit = async (formValues: any) => {
    const payload = {
      noteType: noteData.noteType,
      assessmentType: noteData.assessmentType,
      clientId: formValues.clientId,
      createdBy: authUser.user._id,
      behaviorsMapping: formValues.behaviorsMapping,
      keyContacts: [
          {
            name: formValues.name1,
            relationship: formValues?.relationship1,
            phoneNumber: formValues?.phoneNumber1,
          },
          {
            name: formValues?.name2,
            relationship: formValues?.relationship2,
            phoneNumber: formValues?.phoneNumber2,
          }
      ],
      disability: {
        type1: formValues.type1,
        type2: formValues.type2,
        type3: formValues.type3,
      },
      planPreparedBy: {
        name: formValues.name,
        profession: formValues.profession,
        registrationNumber: formValues.registrationNumber,
      },
      behaviourOfConcern: {
        type: formValues.type,
        description: formValues.description,
        duration: formValues.duration,
        intensity: formValues.intensity,
        settingEvents: formValues.settingEvents,
        triggers: formValues.triggers,
        lowRiskScenarios: formValues.lowRiskScenarios,
        highRiskScenarios: formValues.highRiskScenarios,
        function: formValues.function,
        replacementBehaviour: formValues.replacementBehaviour, 
        behaviouralGoals: formValues.behaviouralGoals,
      },
      baselineAndPrevention: {
        looksLike: formValues.baselineAndPreventionLooksLike,
        participantCanDo: formValues.baselineAndPreventionParticipantCanDo,
        supportTeamCanDo: formValues.baselineAndPreventionSupportTeamCanDo,
      },
      buildUp: {
        looksLike: formValues.buildUpLooksLike,
        participantCanDo: formValues.buildUpParticipantCanDo,
        supportTeamCanDo: formValues.buildUpSupportTeamCanDo,
      },
      when: {
        looksLike: formValues.whenLooksLike,
        participantCanDo: formValues.whenParticipantCanDo,
        supportTeamCanDo: formValues.whenSupportTeamCanDo,
      },
      formulation: formValues.formulation,
      preventativeStrategies: formValues.preventativeStrategies,
      skillBuildingStrategies: formValues.skillBuildingStrategies,
      reinforcementMotivation: formValues.reinforcementMotivation,
      planImplementationSystemSupports: formValues.planImplementationSystemSupports,
    }
    try {
      setIsLoading(true)
      const response = await axios.post('/behavior-assessment/create', payload)
      if(response?.data?.success){
        toast.success('Behaviour assessment created successfully')
        history.push('/notes/behavior-notes/list')
      }
    } catch (error) {
      console.error('Error creating behaviour notes assessment:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outlined',
      type: 'button',
    },
    {
      label: 'Save',
      variant: 'contained',
      type: 'submit',
    },
  ]

  return (
    <FormWrapper
      title='Behavior Assessment'
      content={
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              marginRight: '1rem',
            }}
          >
            <BackButton />
          </div>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 'bold',
              marginBottom: '0.5rem',
              marginLeft: '1rem',
            }}
            color='primary'
          >
            Note Type
          </Typography>
          <Box sx={{ px: 2, mb: 2 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <FrequencyDateRangePicker
                      isEntry={false}
                      isTemplate={true}
                      isFullForm={false}
                      isEdit={false}
                      formData={noteData}
                      setFormData={setNoteData}
                    />
                  </Grid>

                 <Grid item xs={12} sm={6}>
                  <AssessmentTypeSelect
                    value={noteData.assessmentType || ''}
                    onChange={(value) =>
                      setNoteData((prev) => ({ 
                        ...prev, 
                        assessmentType: value 
                      }))
                    }
                  />
                </Grid>
                </Grid>
                </Box>

          {isFormLoading ? (
            <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
              <MoonLoader color='#9db2fc' size={60} loading={isFormLoading} />
            </div>
          ) : ( 
            <DynamicForm
              fields={uiElements}
              data={formData}
              onSubmit={handleSubmit}
              buttons={buttons}
              setFormValues={setFormData}
              noteType={noteData?.noteType}
            />
          )}
        </>
      }
    />
  )
}

export default BehaviourNotesAssessmentNew
